import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { baseTheme } from '../../theme';

import { ILeaderFormData } from '../../services/interfaces';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import FormControl from '@material-ui/core/FormControl';
import StandardInputComponent from '../../components/form-elements/standard-input';

import React, { useState } from 'react';
import SubmitButton from '../../components/form-elements/submit-button';
import { deleteUser } from '../../services/auth/service';
import { useHistory } from 'react-router-dom';
import { ROUTE_PATHS } from '../../contants/ROUTE_PATHS';
import PasswordInputComponent from '../../components/form-elements/password-input';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    formContainer: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderRadius: '5px',
      marginLeft: theme.spacing(0),
      marginRight: theme.spacing(3),
      padding: theme.spacing(1),
    },
    base: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'center',
    },
    inputBase: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: '5px',
    },
    textBlock: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    buttonContainer: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    submitButton: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      fontSize: '1em',
    },
  }),
);
export default function DeleteAccount() {
  const classes = useStyles(baseTheme);
  const auth = useSelector((state: any) => state.auth);
  const profile = useSelector((state: any) => state.user.profile);
  const history = useHistory();
  const defaultFormValues: ILeaderFormData = {
    displayName: '',
    password: '',
    confirmPass: '',
    email: '',
    leaderName: '',
    adminName: '',
    leaderType: '',
    timezone: '',
    referal: '',
    agreeTermsConditions: false,
    photoUrl: null,
    sortPreference: 'all',
    ...profile,
  };

  const [formValues, setFormValues] = useState(defaultFormValues);
  const [inputEmail, setInputEmail] = useState('');
  const [inputPassword, setInputPassword] = useState('');

  const handleInputEmailChange = (event: any) => {
    setInputEmail(event.target.value);
  };

  const handleInputPasswordChange = (event: any) => {
    setInputPassword(event.target.value);
  };

  const handleSubmit = async () => {
    const userCredentials = {
      email: inputEmail,
      password: inputPassword,
    };
    if (inputEmail && inputPassword) {
      try {
        await deleteUser(userCredentials).then(() => {
          history.push(ROUTE_PATHS.HOME);
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formRender = () => {
    if (auth.loading) {
      return null;
    }

    return (
      <Grid item container>
        <Grid item container direction="column" xs={6} md={5} className={classes.formContainer}>
          <Grid item container>
            <FormControl variant="filled" className={classes.inputBase}>
              <StandardInputComponent
                id="inputEmail"
                label="Account Email"
                value={inputEmail}
                onChange={handleInputEmailChange}
              />
            </FormControl>
          </Grid>
          <Grid item container>
            <FormControl variant="filled" className={classes.inputBase}>
              <PasswordInputComponent
                  id="password"
                  label="Password"
                  value={inputPassword}
                  onChange={handleInputPasswordChange}
              />
            </FormControl>
          </Grid>
          <Grid item container>
            <Grid item xs={12} md={6} className={classes.buttonContainer}>
              <SubmitButton
                  className={classes.submitButton}
                  onClick={handleSubmit}
                  text="Delete"
                  variant="light"
                  disabled={!(formValues && inputEmail && formValues.email === inputEmail)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item container direction="column" xs={12} md={6}>
          <Grid item className={classes.textBlock}>
            <Typography variant="h4">
              {`Are you sure you want to delete the account for ${formValues.email}?`}
              <br /><br />
            </Typography>
            <Typography variant="body1">
              Deleting your account will permanently erase all your data.
              You will no longer be able to log in to Reliht
              on the website or the mobile application.
              All posts made by your account will also be removed.
              <br /><br />
              Your posts will not be recoverable even if you re-create your account at a later date.
              <br /><br />
            </Typography>
            <Typography variant="h5" color="primary">
              Enter the email address and password of your account
              to confirm you would like to delete it.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid item container direction="column" className={classes.root}>
      <Typography variant="h4" color="primary">
          <AccountCircleIcon /> Delete Account
          {formRender()}
      </Typography>
    </Grid>
  );
}
